import { useCallback, useState } from "react"

const WIDGET_STATE_KEY = "gotruck_ai_widget_open"

const useChatWidget = () => {
   const [isOpen, setIsOpen] = useState(() => {
      try {
         return localStorage.getItem(WIDGET_STATE_KEY) === "true"
      } catch {
         return false
      }
   })
   const [unreadCount, setUnreadCount] = useState(0)

   const open = useCallback(() => {
      setIsOpen(true)
      setUnreadCount(0)
      try {
         localStorage.setItem(WIDGET_STATE_KEY, "true")
      } catch {
         // Ignore storage errors
      }
   }, [])

   const close = useCallback(() => {
      setIsOpen(false)
      try {
         localStorage.setItem(WIDGET_STATE_KEY, "false")
      } catch {
         // Ignore storage errors
      }
   }, [])

   const toggle = useCallback(() => {
      if (isOpen) {
         close()
      } else {
         open()
      }
   }, [isOpen, open, close])

   const incrementUnread = useCallback(() => {
      setUnreadCount((prev) => prev + 1)
   }, [])

   return {
      isOpen,
      unreadCount,
      open,
      close,
      toggle,
      incrementUnread,
   }
}

export default useChatWidget
